<template>
  <div>
  <special-index v-show="special && special['index/index']" :page-path="'index/index'" :item-id="''"></special-index>
  <div class="container" v-show="!special || !special['index/index']">
    <home-common-search :from='"home"'></home-common-search>
    <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>
    <index-menu  :items="navs"></index-menu>
    <index-article class="mb-5" :items="articles"></index-article>
    <index-floor-ads v-if="floorAds" :ad="floorAds[0]"></index-floor-ads>
    <index-three-ads :items="promotionAds"></index-three-ads>
    <index-product-list
            :items="goodProducts"
            title="热门推荐"
            :type="popular"
            v-if="goodProducts && goodProducts.length > 0"
    ></index-product-list>
    <index-product-list
            :items="hotProducts"
            title="销量排行"
            :type="sale"
            v-if="hotProducts && hotProducts.length > 0"
    ></index-product-list>
    <index-floor-ads v-if="floorAds" :ad="floorAds[1]"></index-floor-ads>
    <index-product-list
            :items="recentlyProducts"
            title="新品上架"
            :type="recently"
            v-if="recentlyProducts && recentlyProducts.length > 0"
    ></index-product-list>
    <!-- 版权信息 -->
    <div class="copyright">
        <div class="app_download">
          <ul>
            <li class="android_app" style="display: none;">
              <a href="https://en.oubv.com/home/Download/?url=comoubven.apk">
                <img src="https://en.oubv.com/static/home/images/app_download.png">
              </a>
            </li>
            <li class="ios_app" style="display: none;">
              <a href="https://apps.apple.com/cn/app/id1560297562">
                <img src="https://en.oubv.com/static/home/images/app_download.png">
              </a>
            </li>
            <li class="change_site" @click="showFooterCurtain=true">
              <img src="https://en.oubv.com/static/home/images/change_site.png">
            </li>
          </ul>
        </div>
        <div v-if="config"><a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{config.wab_number}}</a></div>
        <div v-if="config"><a href="https://beian.miit.gov.cn" target="_blank">{{config.icp_number}}</a></div>
        <div v-if="config">{{config.flow_static_code}}</div>
    </div>
    <!-- 弹窗 -->
    <div id="footerCurtain" class="m-common-footer-curtain" v-if="showFooterCurtain">
      <div class="footerCurtain_mask" @click.prevent="showFooterCurtain=false"></div>
      <div class="footer-curtain-wrapper-content" id="maskWrapperContent">
        <div class="footer-curtain-wrapper-content-title">
          <div class="curtain-title-name">选择站点</div>
          <div class="curtain-title-close iconfont">
            <span id="footerBtnClose" @click="showFooterCurtain=false">&#xe69a;</span>
          </div>
        </div>
        <ul class="footer-curtain-wrapper-content-body" id="footerSiteList">
          <li class="site-list">
            <div class="site-list-item">
              <span class="site-list-item-name">Global Site</span>
              <a href="https://m.en.oubv.com/" class="selected-icon-mask"></a>
            </div>
          </li>
          <li class="site-list">
            <div class="site-list-item">
              <span class="site-list-item-name">中文站</span>
              <a href="https://m.oubv.com/" class="selected-icon-mask"></a>
            </div>
          </li>
          <li class="site-list">
            <div class="site-list-item">
              <span class="site-list-item-name">موقع مصر</span>
              <a href="https://m.eg.oubv.com/" class="selected-icon-mask"></a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import HomeCommonSearch from '../common/HomeCommonSearch'
import IndexBanner from './IndexBanner'
import IndexMenu from './IndexMenu'
import IndexFloorAds from './IndexFloorAds'
import IndexThreeAds from './IndexThreeAds'
import IndexArticle from './IndexArticle'
import {loadScript} from "../../../util/common";
import $ from 'jquery'

export default {
  name: 'HomeIndex',
  data () {
    return {
      uniapp: 0,
      isIos: false,
      isAndroid: false,
      isshowBacktop: true,
      showFooterCurtain: false,
      popular: '',
      sale: 'goods_salenum',
      recently: 'goods_addtime'
    }
  },
  components: {
    SpecialIndex,
    IndexProductList,
    HomeCommonSearch,
    IndexBanner,
    IndexMenu,
    IndexFloorAds,
    IndexThreeAds,
    IndexArticle
  },
  mounted () {
  },
  created: function () {

    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.isAndroid = true;
    }
    if (isIOS) {
      this.isIOS = true;
    }

    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      uni.getEnv(function (res) {
        _this.ifLoaded = true
        if (res.plus) {
          _this.uniapp = 1
        }else{
          if(isAndroid){
            $('.android_app').show()
          }
          if(isIOS){
            $('.ios_app').show()
          }
        }
      })
    })

    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeProduct({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      banners: state => state.home.banners,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      promotionAds: state => state.home.promotionAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts
    })
  },
  methods: {
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    })
  }
}
</script>
<style scoped>
.m-common-footer-curtain{
  box-sizing:border-box;
  position:fixed;
  z-index:9999;
  top:0;
  right:0;
  bottom:0;
  left:0;
}
.footerCurtain_mask{
  position: absolute;
  z-index:10000;
  width: 100%;
  height: 100%;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background-color:rgba(0,0,0,.3);
}
.m-common-footer-curtain ul{
  list-style:none;
  padding-top:6px;
  overflow:scroll;
  overflow-x:hidden;
  max-height:160px;
}
.m-common-footer-curtain .footer-curtain-wrapper-content{
  box-sizing:border-box;
  width:80%;
  border-radius:4.8px;
  background-color:#fff;
  padding-bottom:6px;
  position: absolute;
  z-index:10001;
  left: 10%;
  top: 150px;
}
.m-common-footer-curtain .footer-curtain-wrapper-content-title{
  position:relative;
  border-bottom:1px solid #e5e5e5;
}
.m-common-footer-curtain .footer-curtain-wrapper-content-title .curtain-title-name{
  text-align:center;
  font-size:13px;
  line-height:36px;
  color:#333;
}
.m-common-footer-curtain .footer-curtain-wrapper-content-title .curtain-title-close{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  line-height:36px;
  text-align:right;

}
.m-common-footer-curtain .footer-curtain-wrapper-content-title .curtain-title-close span{
  position:absolute;
  top:50%;
  right:12px;
  -webkit-transform:translate(0,-50%);
  transform:translate(0,-50%);
  color: #d9d9d9;
  font-size: 13px;
}
.site-list-item {
  position: relative;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  padding-left: 12px;
}
.site-list-item .site-list-item-name {
  font-size: 12px;
  color: #333;
}
.site-list-item .selected-icon-mask {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: right;
}

.copyright{
  font-size:.65rem;
  color:#999;
  text-align: center;
  padding:.2rem 0;
}
.app_download{
  border-bottom: 1px solid #e5e5e5;
  padding: 0 0.36rem 0.3rem;
  margin-bottom: 0.36rem;
}
.app_download ul{
  overflow: hidden;
}
.app_download ul li {
  float: left;
  text-align: center;
  width: 33.3333%;
}
.app_download ul li a {
  display: block;
  width: 100%;
  position: relative;
}
.app_download ul li img {
  width: 3rem;
  vertical-align: middle;
}
</style>